import React, { useState, useEffect } from "react";
import { apiFetch } from "../utils/wkCommon";
import ConfirmDangerDialog from "../docs/ConfirmDangerDialog";
import { isZh } from "../utils/language";
import { getUser } from "../utils/auth";

const user = getUser();
const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AlbumForm({ data, onClose, onSaved }) {

  const [form, setForm] = useState({
    title_zh: data?.title_zh || "",
    title_id: data?.title_id || ""
  });

  const [confirmDelete, setConfirmDelete] = useState(false);

  const inputStyle = {
    width: "95%",
    padding: "0.625rem 0.875rem", // pakai rem sesuai requirement
    borderRadius: "0.625rem",
    border: "1px solid #ddd",
    fontSize: "0.875rem"
  };

  async function handleSave() {
    if (data?.documentId) {
      await apiFetch(`/api/song-playlists/${data.documentId}`, {
        method: "PUT",
        body: {
          data: {
            ...form,
            recordEditor: user?.username
          }
        }
      });
    } else {
      await apiFetch(`/api/song-playlists`, {
        method: "POST",
        body: {
          data: {
            ...form,
            recordOwner: user?.username,
            recordEditor: user?.username
          }
        }
      });
    }

    onSaved();
    onClose();
  }

  async function handleDelete() {
    await apiFetch(`/api/song-playlists/${data.documentId}`, {
      method: "DELETE"
    });

    onSaved();
    onClose();
  }

  useEffect(() => {
    if (data) {
      setForm({
        title_zh: data.title_zh || "",
        title_id: data.title_id || ""
      });
    } else {
      setForm({
        title_zh: "",
        title_id: ""
      });
    }
  }, [data]);

  return (
    <>
      <input autoFocus
        placeholder="Title ZH"
        style={inputStyle}
        value={form.title_zh}
        onChange={e => setForm({ ...form, title_zh: e.target.value })}
      />

      <input
        placeholder="Title ID"
        style={inputStyle}
        value={form.title_id}
        onChange={e => setForm({ ...form, title_id: e.target.value })}
      />

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        
        {/* LEFT */}
        <div>
          {data?.documentId && (
            <button
              className="btn-danger"
              onClick={() => setConfirmDelete(true)}
            >
              🗑 Delete
            </button>
          )}
        </div>

        {/* RIGHT */}
        <div>
          <button 
            className="btn-primary"
            disabled={!form.title_zh && !form.title_id} 
            onClick={handleSave}
          >
            Save
          </button>
        </div>

      </div>

      {confirmDelete && (
        <ConfirmDangerDialog
          title={
            isZh()
              ? `刪除專輯「${form.title_zh}」？`
              : `Hapus Album "${form.title_id}"?`
          }
          message={
            isZh()
              ? "此操作將永久刪除此專輯，以及其中所有歌曲的排序與組合。\n\n⚠️ 此操作無法復原，若需要只能重新建立整個清單。"
              : "Tindakan ini akan menghapus album ini beserta seluruh susunan lagu di dalamnya.\n\n⚠️ Tidak dapat dibatalkan. Jika diperlukan, Anda harus membuat ulang playlist dari awal."
          }
          onConfirm={handleDelete}
          onClose={() => setConfirmDelete(false)}
        />
      )}
    </>
  );
}